/**
 * Created by Kevin Dench on 6/15/2016.
 */
/* @ngInject */
export default function QueryApiService($resource, $http, __env) {
    return {
        executePNSearch: function (partNumber, callBack) {
            $resource(
                `${__env.intellidataApiUrl}query/pn/:partNumber`,
                {partNumber: partNumber}
            ).query(callBack);
        },
        executeParameterValueSearch: function (query, callBack, callBackError, queryType) {
            let config = {params: {
                    displayArea: 'COMPONENT_EDGE_PART_SUMMARY',
                    filterRemainingPossibleValuesByDisplayArea: false
                }
            };
            if (queryType !== undefined) {
                config.headers = {'query-type': queryType}
            }
            $http.post(
                `${__env.intellidataApiUrl}query/parameter-values`,
                query,
                config
            ).then(({data}) => {
                callBack(data);
            })['catch'](function (errorData) {
                if (callBackError !== undefined) {
                    callBackError(errorData);
                } else {
                    console.log(errorData);
                }
            });
        },
        executeQueryByRaw: function (rawInput, callBack, callBackError) {
            $http.post(
                `${__env.intellidataApiUrl}query/raw`,
                rawInput,
                {
                    params: {
                        displayArea: 'COMPONENT_EDGE_PART_SUMMARY',
                        filterRemainingPossibleValuesByDisplayArea: false
                    }
                }
            ).then(({data}) => {
                if (typeof data === 'string') {
                    data = {
                        message: null,
                        detectedDefinition: null
                    };
                }
                callBack(data);
            })['catch'](function (errorData, status) {
                console.error(status);
                callBackError(errorData);
            });
        },
        executeXref: function (input, callBack) {
            $http.post(
                `${__env.intellidataApiUrl}'query/xref`,
                input,
                {params: {}}
            ).then(({data}) => {
                callBack(data);
            });
        }
    };
}
